import { Link } from 'react-router-dom';
import { taskRules } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';

export default function TaskRulesSection() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <SectionHeading
        eyebrow="任务奖励速查"
        tone="secondary"
        title="做哪些任务能拿多少奖励，一张表看懂"
        desc="下面是最常见的六类任务及其奖励标准。不同活动的具体数值可能略有调整，请以活动详情页为准。"
      />

      <div className="mt-10 bg-background-100 border border-background-200 rounded-2xl overflow-hidden">
        <div className="w-full overflow-x-auto">
          <table className="w-full min-w-[720px] text-left border-collapse">
            <thead>
              <tr className="bg-background-200/60 text-foreground-700 text-sm">
                <th scope="col" className="px-5 py-4 font-medium whitespace-nowrap">任务类型</th>
                <th scope="col" className="px-5 py-4 font-medium">完成条件</th>
                <th scope="col" className="px-5 py-4 font-medium whitespace-nowrap">奖励</th>
                <th scope="col" className="px-5 py-4 font-medium whitespace-nowrap">次数限制</th>
                <th scope="col" className="px-5 py-4 font-medium whitespace-nowrap">到账时间</th>
              </tr>
            </thead>
            <tbody>
              {taskRules.map((rule) => (
                <tr key={rule.name} className="border-t border-background-200 hover:bg-background-100/60 transition-colors">
                  <td className="px-5 py-4 text-sm font-medium text-foreground-950 whitespace-nowrap">{rule.name}</td>
                  <td className="px-5 py-4 text-sm text-foreground-600">{rule.require}</td>
                  <td className="px-5 py-4 text-sm text-primary-700 font-medium whitespace-nowrap">{rule.reward}</td>
                  <td className="px-5 py-4 text-sm text-foreground-600 whitespace-nowrap">{rule.limit}</td>
                  <td className="px-5 py-4 text-sm text-foreground-600 whitespace-nowrap">{rule.time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 bg-secondary-50 border border-secondary-200 rounded-2xl p-5 md:p-6">
        <p className="text-sm text-secondary-900 leading-relaxed text-center sm:text-left">
          奖励规则会随活动调整，参与前建议先看一眼活动详情页的最新说明，避免用旧规则计算预期。
        </p>
        <Link
          to="/rules"
          className="shrink-0 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors cursor-pointer"
        >
          完整规则说明
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}